import { AddProps, convertProps, IFormItemProps, MyModal } from "@/Common/Form/MyModal";
import { SysUserGroup } from "@/Models/Tables/SysUserGroup";
import { Form, Input } from "antd";
import React from "react";
import { useCallback } from "react";

function Item(props: IFormItemProps<SysUserGroup>) {
    return <Form.Item {...convertProps(props)}  ></Form.Item>;
}

function Add({ onCancel, onSubmit, data }: AddProps<SysUserGroup>) {
    const [form] = Form.useForm();
    const onOk = useCallback(() => {
        form.validateFields().then(onSubmit);
    }, [form, onSubmit]);
    return <MyModal name="用户组" data={data} width={360} onCancel={onCancel} onOk={onOk}>
        <Form form={form} labelAlign="right" initialValues={data} labelCol={{ span: 8 }}>
            <Item name="name" label="用户组名称" required >
                <Input ></Input>
            </Item>
            <Item name="code" label="用户组编码" required >
                <Input ></Input>
            </Item>
            <Item name="remark" label="备注" >
                <Input.TextArea rows={3} ></Input.TextArea>
            </Item>
        </Form>
    </MyModal>;
}

export default Add;